import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Calendar, FileText, Users, MapPin, Clock, Folder } from "lucide-react";
import VideoCarousel from "./VideoCarousel";

// Entrance animations
const sectionVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: { delay: 0.5 * i, duration: 1.2, ease: "easeOut" },
  }),
};

export default function LandingPage({featuresRef=null, onHandleVideoModal, isModalOpen}) {
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const openModal = () => setIsModalOpen(true);
  // const closeModal = () => setIsModalOpen(false);
    

  // Button styles
  const primaryBtn =
    "inline-flex items-center justify-center px-10 py-4 text-lg font-semibold rounded-full shadow-lg transition-transform duration-500 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#64c27b] bg-gradient-to-r from-[#64c27b] to-[#2a8c4a] text-white";
  const secondaryBtn =
    "inline-flex items-center justify-center px-8 py-3 text-base font-medium rounded-full border-2 border-[#2a8c4a] text-[#2a8c4a] bg-white shadow-sm transition-transform duration-500 transform hover:scale-105 hover:bg-[#2a8c4a] hover:text-white";
  const cardClasses =
    "flex flex-col items-center text-center p-6 bg-white shadow-md transition-transform duration-500 hover:shadow-xl hover:-translate-y-1 rounded-lg";

  return (
    <AnimatePresence exitBeforeEnter>
      <motion.div
        className="mb-50 bg-white"
        initial="hidden"
        animate="visible"
        variants={sectionVariants}
        custom={0}
      >
        {/* Hero Section */}
        <motion.section
          className="py-20 bg-gray-50"
          variants={sectionVariants}
          custom={1}
        >
          <motion.div
            className="container mx-auto px-6 text-center"
            variants={sectionVariants}
            custom={1.2}
          >
            <motion.h1
              className="text-4xl font-extrabold mb-4 text-[#2a8c4a]"
              whileHover={{ scale: 1.02 }}
            >
              Pasaporte hacia el Empleo: Conectando Talento y Oportunidades
            </motion.h1>
            <p className="text-lg text-gray-600 mb-6">
              Pasaporte hacia el Empleo es un proyecto de la{" "}
              <a
                href="https://eracis.islacristina.org/portfolio-item/red-de-empleo/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-[#2a8c4a]"
              >
                Red de Empleo de Isla Cristina
              </a>
            </p>
            <motion.div
              className="max-w-4xl mx-auto mb-8 grid grid-cols-1 sm:grid-cols-2 gap-6"
              variants={sectionVariants}
              custom={1.4}
            >
              {[
                {
                  icon: Calendar,
                  title: "Centralización total",
                  desc: "Acceso unificado a datos personales y laborales.",
                },
                {
                  icon: Folder,
                  title: "Visión completa",
                  desc: "Seguimiento detallado del itinerario sociolaboral.",
                },
                {
                  icon: FileText,
                  title: "Gestión eficiente",
                  desc: "Organización de documentación y derivaciones ágiles.",
                },
                {
                  icon: Users,
                  title: "Colaboración óptima",
                  desc: "Intercambio fluido de información entre entidades.",
                },
              ].map((item, idx) => {
                const Icon = item.icon;
                return (
                  <motion.div
                    key={idx}
                    className="flex items-start p-6 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
                    whileHover={{ scale: 1.03 }}
                  >
                    <div className="p-3 bg-gradient-to-r from-[#64c27b] to-[#2a8c4a] text-white rounded-full">
                      <Icon className="w-6 h-6" />
                    </div>
                    <div className="ml-4 text-left">
                      <h4 className="text-lg font-semibold text-gray-800">
                        {item.title}
                      </h4>
                      <p className="text-gray-600 mt-1">{item.desc}</p>
                    </div>
                  </motion.div>
                );
              })}
            </motion.div>
            <motion.div whileHover={{ scale: 1.05 }}>
              <button onClick={onHandleVideoModal} className={primaryBtn}>
                Ver Demostración
              </button>
            </motion.div>
          </motion.div>
        </motion.section>

        {/* Modal Video */}
        {isModalOpen && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.8 } }}
            exit={{ opacity: 0, transition: { duration: 0.5 } }}
          >
            <motion.div
              className=" w-[75%] lg:w-full md:max-w-3xl mx-4 bg-white rounded-lg shadow-lg mt-[15vh]"
              initial={{ scale: 0.7 }}
              animate={{ scale: 1, transition: { duration: 0.8 } }}
              exit={{ scale: 0.7, transition: { duration: 0.5 } }}
            >
           
                {/* <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube.com/embed/baDF_xvch-g?autoplay=1"
                  title="Demostración"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                /> */}
                 <VideoCarousel />
              <div className="p-4 text-right">
                <button onClick={onHandleVideoModal} className="inline-flex items-center justify-center px-2 sm:px-8 py-2 sm:py-3  text-xs sm:text-base font-medium sm:rounded-full border-2 border-[#2a8c4a] text-[#2a8c4a] bg-white shadow-sm transition-transform duration-500 transform hover:scale-105 hover:bg-[#2a8c4a] hover:text-white">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}

        {/* Features Section */}
        <motion.section
          className="py-20 bg-gray-100"
          variants={sectionVariants}
          custom={2}
          ref={featuresRef}
        >
          <motion.h2
            className="text-3xl font-bold text-center text-gray-800 mb-8"
            variants={sectionVariants}
            custom={2.1}
          >
            Características Principales
          </motion.h2>
          <motion.div
            className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8"
            variants={sectionVariants}
            custom={2.2}
          >
            {[
              {
                icon: Calendar,
                title: "Agenda Digital",
                text: "Conoce y solicita citas en entidades sociolaborales de forma rápida y sencilla.",
              },
              {
                icon: FileText,
                title: "CV Dinámico",
                text: "Crea, actualiza y recibe un seguimiento personalizado para la mejora de tu currículum.",
              },
              {
                icon: MapPin,
                title: "Ofertas Locales",
                text: "Localiza oportunidades de empleo y formación en tu área geográfica.",
              },
              {
                icon: Users,
                title: "Red Colaborativa",
                text: "Accede a recursos socioeconómicos y conecta con servicios de apoyo.",
              },
            ].map((item, index) => {
              const Icon = item.icon;
              return (
                <motion.div
                  key={index}
                  className={cardClasses}
                  whileHover={{ y: -10, scale: 1.03 }}
                >
                  <motion.div whileHover={{ rotate: 15 }}>
                    <Icon className="w-12 h-12 text-[#2a8c4a] mb-4" />
                  </motion.div>
                  <motion.h3
                    className="text-xl font-semibold mb-2"
                    whileHover={{ color: "#64c27b" }}
                  >
                    {item.title}
                  </motion.h3>
                  <motion.p
                    className="text-gray-700"
                    whileHover={{ opacity: 0.8 }}
                  >
                    {item.text}
                  </motion.p>
                </motion.div>
              );
            })}
          </motion.div>
        </motion.section>

        {/* How It Works: Elegant Cards */}
        <motion.section
          className="py-20 bg-gray-200"
          variants={sectionVariants}
          custom={3}
        >
          <motion.div
            className="container mx-auto px-6 lg:px-10"
            variants={sectionVariants}
            custom={3.2}
          >
            <motion.h2
              className="text-3xl font-bold text-center text-gray-800 mb-12"
              whileHover={{ scale: 1.02 }}
            >
              ¿Cómo Funciona?
            </motion.h2>
            <motion.div
              className="flex flex-wrap gap-[2rem] lg:gap-10 justify-center"
              variants={sectionVariants}
              custom={3.4}
            >
              {[
                {
                  icon: Clock,
                  title: "Seguimiento Personalizado",
                  desc: "Cada usuario cuenta con un itinerario adaptado a sus necesidades, con alertas y recordatorios automáticos.",
                },
                {
                  icon: Folder,
                  title: "Gestión Centralizada",
                  desc: "Toda la documentación y seguimiento de itinerarios en un único panel interactivo.",
                },
                {
                  icon: Users,
                  title: "Promueve la Colaboración",
                  desc: "Facilita derivaciones e intercambio de información entre entidades para optimizar recursos.",
                },
              ].map((item, idx) => {
                const Icon = item.icon;
                return (
                  <motion.div
                    key={idx}
                    className="bg-white p-8 rounded-lg shadow-lg flex flex-col items-center text-center basis-[300px] lg:basis-[420px] flex-shrink-0"
                    whileHover={{
                      y: -10,
                      scale: 1.03,
                      boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <motion.div
                      className="w-16 h-16 mb-4 flex items-center justify-center bg-gradient-to-r from-[#64c27b] to-[#2a8c4a] text-white rounded-full"
                      whileHover={{ rotate: 360 }}
                      transition={{ duration: 1 }}
                    >
                      <Icon className="w-8 h-8" />
                    </motion.div>
                    <motion.h3
                      className="text-2xl font-semibold mb-3 text-gray-800"
                      whileHover={{ color: "#2a8c4a" }}
                    >
                      {item.title}
                    </motion.h3>
                    <motion.p
                      className="text-gray-700"
                      whileHover={{ opacity: 0.8 }}
                    >
                      {item.desc}
                    </motion.p>
                  </motion.div>
                );
              })}
            </motion.div>
          </motion.div>
        </motion.section>
      </motion.div>
    </AnimatePresence>
  );
}
